import { Component, OnInit, OnDestroy} from "@angular/core";
import { MainService } from "src/app/Services/service.service";

import { ActivatedRoute,  Router, Params } from "@angular/router";
import { switchMap, takeUntil, map } from "rxjs/operators";
import { Subject } from "rxjs";
import { AdveristmentsClient, SearchParamsRequest } from './../../../api/WickedApiClient';
import { SeoService } from './../../../Services/seo.service';


interface IUrlSearchParams {
  casualDating: string,
  city: string,
  page: number,
  relationShip: string,
  state: string,
  withPicture: string
}

@Component({
  selector: "app-route-search-results",
  templateUrl: "./route-search-results.component.html",
  styleUrls: ["./route-search-results.component.css"]
})
export class RouteSeachResults implements OnInit, OnDestroy {

  private destroy = new Subject<void>();

  constructor(public service: MainService, private route: ActivatedRoute, private advertisementClient: AdveristmentsClient, private seo: SeoService) {

  }


  ngOnInit() {
    this.route.params.pipe(map(paramMap => paramMap), takeUntil(this.destroy)).subscribe(routeParamPath => {
      this.updateSearch(routeParamPath);
    });

    this.service.advService.searchInAction = true;
  }

  updateSearch(params: Params) {
    let category = params["category"];
    let city = params["city"];
    let state = params["state"];
    let type = params["type"];
    let withPicture = params["withPicture"];
    let page = params["page"] ? params["page"].replace(/\D/g,'') : 1;
    let perPage = params["per"] ? params["per"].replace(/\D/g,'') : 24;

    this.advertisementClient.getSearchParams(new SearchParamsRequest({ category: category, city: city, state: state, type: type, withPicture: withPicture })).toPromise().then(response => {
      this.service.advService.searchDataStandard.currentSearchRule = {
        advertisementCategoryId: response.categoryId,
        casualDating: response.casualDating,
        pageNumber: page > 0 ? (page - 1) : 0,
        pageSize: parseInt(perPage),
        showExpired: false,
        showActive: true,
        regionId: response.regionId,
        subRegionId: response.subregionId,
        withPicturesOnly: response.withPicture,
        keywords: this.service.advService.searchDataStandard.currentSearchRule.keywords
      }
      this.service.advService.searchAction(false);
    });

  }



  ngOnDestroy() {
    this.destroy.next();
    this.destroy.complete();
  }
}
